__turbopack_context__.v({
  "button": "cyanora-module-scss-module__cqzZUq__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "cyanora-module-scss-module__cqzZUq__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "cyanora-module-scss-module__cqzZUq__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "cyanora-module-scss-module__cqzZUq__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "cyanora-module-scss-module__cqzZUq__small" + " " + __turbopack_context__.i(693367)["small"],
});
